export enum LanguageEnum {
  ENGLISH = "en",
  // SPANISH = "es",
  FRENCH = "fr",
}
